import type { TicketingAnalyticsFilterOptionsResponse } from '../pages/TicketingAnalytics/types';

export const TICKETING_FILTER_OPTIONS_MOCK: TicketingAnalyticsFilterOptionsResponse = {
	regions: [
		{ id: 1, displayText: 'North America' },
		{ id: 2, displayText: 'Europe' },
		{ id: 3, displayText: 'APAC' },
	],
	markets: [
		{ id: 11, displayText: 'Texas' },
		{ id: 12, displayText: 'Chicago' },
		{ id: 13, displayText: 'California' },
	],
	locations: [
		{ id: 101, displayText: 'Dallas Plant' },
		{ id: 102, displayText: 'Austin Plant' },
		{ id: 103, displayText: 'Chicago Plant' },
	],
	categories: [
		{ id: 1, displayText: 'System Issue' },
		{ id: 2, displayText: 'Reporting' },
		{ id: 3, displayText: 'Access Request' },
		{ id: 4, displayText: 'Training' },
		{ id: 5, displayText: 'System Enhancement' },
	],
	subCategories: [
		{ id: 101, displayText: 'Navigator' },
		{ id: 102, displayText: 'Vision Pick (WES)' },
		{ id: 103, displayText: 'New' },
		{ id: 104, displayText: 'Enhancement' },
		{ id: 105, displayText: 'Fix' },
	],
	statuses: [
		{ id: 'New', displayText: 'New' },
		{ id: 'In Progress', displayText: 'In Progress' },
		{ id: 'Escalated to IT', displayText: 'Escalated to IT' },
		{ id: 'Escalated to TMV', displayText: 'Escalated to TMV' },
		{ id: 'Submitted to ADO', displayText: 'Submitted to ADO' },
		{ id: 'Waiting on User', displayText: 'Waiting on User' },
		{ id: 'Closed', displayText: 'Closed' },
		{ id: 'Closed (Merged)', displayText: 'Closed (Merged)' },
	],
	resolutionPaths: [
		{ id: 'Resolved by Sustain', displayText: 'Resolved by Sustain' },
		{ id: 'Requires IT', displayText: 'Requires IT' },
		{ id: 'Requires TMV', displayText: 'Requires TMV' },
		{ id: 'Submitted to ADO', displayText: 'Submitted to ADO' },
	],
	urgencies: [
		{ id: 'Critical', displayText: 'Critical' },
		{ id: 'High', displayText: 'High' },
		{ id: 'Medium', displayText: 'Medium' },
		{ id: 'Low', displayText: 'Low' },
	],
	assignedTo: [
		{ id: 'USR001', displayText: 'John Smith' },
		{ id: 'USR002', displayText: 'Jane Doe' },
		{ id: 'USR003', displayText: 'David Miller' },
	],
};
